import React from "react";

const FoodAnalysisResults = ({ response = {} }) => {
  let parsedResponse = response;

  try {
    if (typeof response === "string") {
      parsedResponse = JSON.parse(response);
    }
  } catch (error) {
    console.error("Error parsing JSON response:", error);
  }

  console.log("Parsed Response:", parsedResponse); // Log the parsed response

  const handlePrintView = () => {
    try {
      const resultsContent = document.getElementById("food-safety-results").innerHTML;
      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.write(`
          <!DOCTYPE html>
          <html lang="en">
          <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Print Food Analysis Results</title>
              <style>
                  body {
                      font-family: Arial, sans-serif;
                      margin: 20px;
                      line-height: 1.6;
                  }
              </style>
          </head>
          <body>
              ${resultsContent}
          </body>
          </html>
        `);
        newWindow.document.close();
      }
    } catch (error) {
      console.error("Error generating print view:", error);
    }
  };

  return (
    <div id="food-safety-results">
      <div className="header">
        <h1>Your Food Analysis Results</h1>
      </div>
      <hr className="custom-line" />

      {/* Food Item */}
      {parsedResponse.FoodItem && (
        <div className="section">
          <h2>Food Item: {parsedResponse.FoodItem}</h2>
        </div>
      )}

      {/* Origin and Production */}
      <div className="section">
        <h2>Origin and Production</h2>
        <ul>
        <li><strong>Geographic Source Regions:</strong> {parsedResponse.OriginAndProduction.GeographicSourceRegions}</li>
        <li><strong>Cultivation Methods:</strong> {parsedResponse.OriginAndProduction.CultivationMethods}</li>
        <li><strong>Supply Chain Considerations:</strong> {parsedResponse.OriginAndProduction.SupplyChainConsiderations}</li>
        <li><strong>Seasonal Variations:</strong> {parsedResponse.OriginAndProduction.SeasonalVariations}</li>
        </ul>
      <br></br>
      {/* Toxicological Assessment */}
        <h2>Toxicological Assessment</h2>
        <ul>
        <li><strong>Natural Toxins and Anti-Nutrients:</strong> {parsedResponse.ToxicologicalAssessment.NaturalToxinsAntiNutrients}</li>
        <li><strong>Agricultural Contaminants:</strong> {parsedResponse.ToxicologicalAssessment.AgriculturalContaminants}</li>
        <li><strong>Processing Induced Compounds:</strong> {parsedResponse.ToxicologicalAssessment.ProcessingInducedCompounds}</li>
        <li><strong>Environmental Pollutants:</strong> {parsedResponse.ToxicologicalAssessment.EnvironmentalPollutants}</li>
        <li><strong>Heavy Metals:</strong> {parsedResponse.ToxicologicalAssessment.HeavyMetals}</li>
        <li><strong>Mycotoxins:</strong> {parsedResponse.ToxicologicalAssessment.Mycotoxins}</li>
        <li><strong>Bioaccumulation Potential:</strong> {parsedResponse.ToxicologicalAssessment.BioaccumulationPotential}</li>
        </ul>
        <br></br>

      {/* Half-Life and Retention Factors */}
        <h2>Half-Life and Retention Factors</h2>
        <ul>
        <li><strong>Biological Half-Life:</strong> {parsedResponse.HalfLifeAndRetentionFactors.BiologicalHalfLife}</li>
        <li><strong>Elimination Pathways:</strong> {parsedResponse.HalfLifeAndRetentionFactors.EliminationPathways}</li>
        <li><strong>Retention in Tissues:</strong> {parsedResponse.HalfLifeAndRetentionFactors.RetentionInTissues}</li>
        <li><strong>Cumulative Effects:</strong> {parsedResponse.HalfLifeAndRetentionFactors.CumulativeEffects}</li>
        <li><strong>Factors Influencing Clearance:</strong> {parsedResponse.HalfLifeAndRetentionFactors.FactorsInfluencingClearance}</li>
        </ul>
        <br></br>
      {/* Consumer Safety Data */}
        <h2>Consumer Safety Data</h2>
        <ul>
        <li><strong>Recent Consumer Reports Findings:</strong> {parsedResponse.ConsumerSafetyData.RecentConsumerReportsFindings}</li>
        <li><strong>Independent Laboratory Testing Results:</strong> {parsedResponse.ConsumerSafetyData.IndependentLaboratoryTestingResults}</li>
        <li><strong>Brand Specific Concerns:</strong> {parsedResponse.ConsumerSafetyData.BrandSpecificConcerns}</li>
        <li><strong>Comparative Safety Data:</strong> {parsedResponse.ConsumerSafetyData.ComparativeSafetyData}</li>
        <li><strong>Regulatory Violations or Recalls:</strong> {parsedResponse.ConsumerSafetyData.RegulatoryViolationsOrRecalls}</li>
        </ul>
        <br></br>

      {/* Contamination Analysis */}
        <h2>Contamination Analysis</h2>
        <ul>
        <li><strong>Measured Contaminant Levels:</strong> {parsedResponse.ContaminationAnalysis.MeasuredContaminantLevels}</li>
        <li><strong>Comparison to Safety Standards:</strong> {parsedResponse.ContaminationAnalysis.ComparisonToSafetyStandards}</li>
        <li><strong>Batch Variation Data:</strong> {parsedResponse.ContaminationAnalysis.BatchVariationData}</li>
        <li><strong>Processing Impact on Toxins:</strong> {parsedResponse.ContaminationAnalysis.ProcessingImpactOnToxins}</li>
        <li><strong>Storage Impact on Contamination:</strong> {parsedResponse.ContaminationAnalysis.StorageImpactOnContamination}</li>
        <li><strong>Half-Life and Clearance:</strong> {parsedResponse.ContaminationAnalysis.HalfLifeAndClearance}</li>
        </ul>
        <br></br>
      {/* Risk Stratification */}
        <h2>Risk Stratification</h2>
        <h3>Low Risk</h3>
        <ul>
        <li><strong>Consumption Levels:</strong> {parsedResponse.RiskStratification.LowRisk.ConsumptionLevels}</li>
        <li><strong>Population Groups:</strong> {parsedResponse.RiskStratification.LowRisk.PopulationGroups}</li>
        <li><strong>Preparation Methods:</strong> {parsedResponse.RiskStratification.LowRisk.PreparationMethods}</li>
        </ul>
        <h3>Medium Risk</h3>
        <ul>
        <li><strong>Consumption Levels:</strong> {parsedResponse.RiskStratification.MediumRisk.ConsumptionLevels}</li>
        <li><strong>Population Groups:</strong> {parsedResponse.RiskStratification.MediumRisk.PopulationGroups}</li>
        <li><strong>Preparation Methods:</strong> {parsedResponse.RiskStratification.MediumRisk.PreparationMethods}</li>
        </ul>
        <h3>High Risk</h3>
        <ul>
        <li><strong>Consumption Levels:</strong> {parsedResponse.RiskStratification.HighRisk.ConsumptionLevels}</li>
        <li><strong>Population Groups:</strong> {parsedResponse.RiskStratification.HighRisk.PopulationGroups}</li>
        <li><strong>Preparation Methods:</strong> {parsedResponse.RiskStratification.HighRisk.PreparationMethods}</li>
        </ul>
        <br></br>
      {/* Consumption Guidelines */}
        <h2>Consumption Guidelines</h2>
        <ul>
        <li><strong>Safe Daily Intake Levels:</strong> {parsedResponse.ConsumptionGuidelines.SafeDailyIntakeLevels}</li>
        <li><strong>Weekly Consumption Limits:</strong> {parsedResponse.ConsumptionGuidelines.WeeklyConsumptionLimits}</li>
        <li><strong>High Risk Populations:</strong> {parsedResponse.ConsumptionGuidelines.HighRiskPopulations}</li>
        <li><strong>Timing Considerations:</strong> {parsedResponse.ConsumptionGuidelines.TimingConsiderations}</li>
        <li><strong>Preparation Methods to Reduce Risks:</strong> {parsedResponse.ConsumptionGuidelines.PreparationMethodsToReduceRisks}</li>
        </ul>
        <br></br>
        {/* Longevity Focused Analysis */}
        <h2>Longevity Focused Analysis</h2>
        <h3>Nutritional Composition</h3>
        <ul>
        <li><strong>Protein Content:</strong> {parsedResponse.LongevityFocusedAnalysis.NutritionalComposition.ProteinContent}</li>
        <li><strong>Sugar Content:</strong> {parsedResponse.LongevityFocusedAnalysis.NutritionalComposition.SugarContent}</li>
        <li><strong>Calcium and Vitamin D:</strong> {parsedResponse.LongevityFocusedAnalysis.NutritionalComposition.CalciumAndVitaminD}</li>
        <li><strong>Fat Content:</strong> {parsedResponse.LongevityFocusedAnalysis.NutritionalComposition.FatContent}</li>
        </ul>
        <h3>Probiotic Content</h3>
        <ul>
        <li><strong>Live and Active Cultures:</strong> {parsedResponse.LongevityFocusedAnalysis.ProbioticContent.LiveAndActiveCultures}</li>
        <li><strong>Diversity of Strains:</strong> {parsedResponse.LongevityFocusedAnalysis.ProbioticContent.DiversityOfStrains}</li>
        <li><strong>CFU Counts:</strong> {parsedResponse.LongevityFocusedAnalysis.ProbioticContent.CFUCounts}</li>
        </ul>
        <h3>Clean Ingredients</h3>
        <ul>
        <li><strong>Minimal Additives:</strong> {parsedResponse.LongevityFocusedAnalysis.CleanIngredients.MinimalAdditives}</li>
        <li><strong>Organic Options:</strong> {parsedResponse.LongevityFocusedAnalysis.CleanIngredients.OrganicOptions}</li>
        </ul>
        <h3>Sustainability</h3>
        <ul>
        <li><strong>Grass Fed or Pasture Raised Sources:</strong> {parsedResponse.LongevityFocusedAnalysis.Sustainability.GrassFedOrPastureRaisedSources}</li>
        <li><strong>Sustainable Packaging:</strong> {parsedResponse.LongevityFocusedAnalysis.Sustainability.SustainablePackaging}</li>
        </ul>
        <h3>Specific Health Goals</h3>
        <ul>
        <li><strong>Gut Health:</strong> {parsedResponse.LongevityFocusedAnalysis.SpecificHealthGoals.GutHealth}</li>
        <li><strong>Heart Health:</strong> {parsedResponse.LongevityFocusedAnalysis.SpecificHealthGoals.HeartHealth}</li>
        <li><strong>Bone Health:</strong> {parsedResponse.LongevityFocusedAnalysis.SpecificHealthGoals.BoneHealth}</li>
        <li><strong>Anti-Inflammatory Potential:</strong> {parsedResponse.LongevityFocusedAnalysis.SpecificHealthGoals.AntiInflammatoryPotential}</li>
        <li><strong>Sleep and Recovery:</strong> {parsedResponse.LongevityFocusedAnalysis.SpecificHealthGoals.SleepAndRecovery}</li>

        </ul>

              {/* Safer Alternatives */}
      {parsedResponse.SaferAlternatives && parsedResponse.SaferAlternatives.length > 0 && (
        <div className="section">
          <h2>Safer Alternatives</h2>
          {parsedResponse.SaferAlternatives.map((alternative, index) => (
            <div key={index}>
              <h3>{alternative.AlternativeName}</h3>
              <ul>
              <li><strong>Consumer Report Findings:</strong> {alternative.ConsumerReportFindings}</li>
              <li><strong>Heavy Metal Testing:</strong> {alternative.HeavyMetalTesting}</li>
              <li><strong>Toxicological Profile:</strong> {alternative.ToxicologicalProfile}</li>
              <li><strong>Nutritional Comparison:</strong> {alternative.NutritionalComparison}</li>
              <li><strong>Risk Assessment:</strong> {alternative.RiskAssessment}</li>
              <li><strong>Availability and Cost Comparison:</strong> {alternative.AvailabilityAndCostComparison}</li>
              </ul>
            </div>
          ))}
        </div>
      )}
      
     {/* Recommendations */}
     {/* <div className="section"> */}
        <h2>Recommendations</h2>
        <ul>
        <li><strong>Consumption Guidelines:</strong> {parsedResponse.Recommendations.ConsumptionGuidelines}</li>
        <li><strong>Best Sourcing Practices:</strong> {parsedResponse.Recommendations.BestSourcingPractices}</li>
        <li><strong>Preparation Guidelines:</strong> {parsedResponse.Recommendations.PreparationGuidelines}</li>
        <li><strong>Population Specific Advice:</strong> {parsedResponse.Recommendations.PopulationSpecificAdvice}</li>
        <li><strong>Risk Mitigation Strategies:</strong> {parsedResponse.Recommendations.RiskMitigationStrategies}</li>
        </ul>
      </div>



      {/* Print View Button */}
      <button
        id="print-view-button"
        className="button-style"
        onClick={handlePrintView}
      >
        Print View
      </button>
    </div>
  );
};

export default FoodAnalysisResults;